import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import NoDataDiv from "../Display/NoDataDiv";
import { Theme } from "../../data/style/Theme";
import { useQuery } from "@tanstack/react-query";
import { getScoreRange } from "../../api/workouts";
import { useAuth } from "../../context/AuthContext";
import { CenteredRow, MainText } from "../../data/style/Style";
import {
  ScatterChart,
  Scatter,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Cell,
} from "recharts";

const CustomTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    var data = payload[1].payload;
    return (
      <Stack
        sx={{
          background: Theme.palette.surface,
          width: "150px",
          padding: 1,
          border: 1,
          borderRadius: 4,
          borderColor: Theme.palette.border,
        }}
        // alignItems={"start"}
        gap={1}
      >
        <MainText fontSize={"0.8rem"}>
          <span style={{ color: Theme.palette.orange }}>Athlete:</span>&nbsp;
          {data.athlete_name}
        </MainText>

        <MainText fontSize={"0.8rem"}>
          <span style={{ color: Theme.palette.orange }}>Age:</span>&nbsp;
          {data.user_age}
        </MainText>
        <MainText fontSize={"0.8rem"}>
          <span style={{ color: Theme.palette.orange }}>Score:</span>&nbsp;
          {data.converted_score}
        </MainText>
      </Stack>
    );
  }

  return null;
};

const ScatterCh = (props) => {
  let { workoutId, wod_type, wod_rest } = props;
  const { profile } = useAuth();

  const { data, isPending } = useQuery({
    queryKey: ["score", "range", "workout", workoutId],
    queryFn: ({ signal }) => getScoreRange({ workoutId, signal }),
  });

  const axisClass = {
    fill: Theme.palette.text,
    fontFamily: "DM sans",
    fontSize: "0.9rem",
  };

  return (
    <Stack height={"100%"} gap={1}>
      {!isPending && data.length > 0 ? (
        <>
          <CenteredRow gap={1}>
            <Box
              sx={{
                width: 10,
                height: 10,
                borderRadius: "50%",
                background: Theme.palette.orange,
              }}
            />
            <MainText
              sx={{
                fontSize: "0.7rem",
                color: Theme.palette.muted + " !important",
              }}
            >
              You
            </MainText>
            <Box
              sx={{
                width: 10,
                height: 10,
                borderRadius: "50%",
                background: Theme.palette.blue,
              }}
            />
            <MainText
              sx={{
                fontSize: "0.7rem",
                color: Theme.palette.muted + " !important",
              }}
            >
              Others
            </MainText>
          </CenteredRow>
          <ResponsiveContainer width="100%" height={"100%"}>
            <ScatterChart
              margin={{
                top: 10,
                right: 20,
                left: -20,
              }}
            >
              <XAxis
                type="number"
                dataKey="user_age"
                name="Age"
                domain={[15, 50]}
                tick={axisClass}
              />
              <YAxis
                tick={axisClass}
                type="number"
                dataKey="score"
                name="Score"
                tickFormatter={(value) =>
                  wod_type === 1 || (wod_type === 4 && wod_rest === 0)
                    ? parseInt(value / 60)
                    : value
                }
              />
              <Tooltip
                cursor={{ strokeDasharray: "3 3" }}
                content={<CustomTooltip />}
              />
              <Scatter data={data}>
                {data?.map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={
                      entry.user === profile.user
                        ? Theme.palette.orange
                        : Theme.palette.blue
                    }
                  />
                ))}
              </Scatter>
            </ScatterChart>
          </ResponsiveContainer>
        </>
      ) : (
        <NoDataDiv text={"No data available"} height={"100%"} />
      )}
    </Stack>
  );
};

export default ScatterCh;
